export default "__VITE_PUBLIC_ASSET__05433380__"